import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { DocumentApi } from '../../../apis/Documents/DocumentApi';
import { Document } from '../Document';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export function useGetDocuments(patientId?: string) {
  return useHighFrequencyRefreshQuery({
    queryKey: [QueryKeys.documents, patientId],
    queryFn: async () => {
      const result =  await DocumentApi.getDocuments(patientId!);
      return result?.map((x) => new Document(x)) ?? [];
    },
    enabled: !!patientId,
  });
} 